import { addClassNameTo, cn } from '@navinc/base-react-components'
import { DetailedHTMLProps, HTMLAttributes } from 'react'

const borderClassName = (checked?: boolean, disabled?: boolean) => {
  if (disabled) return 'border-onSurfaceDim'
  return checked ? 'border-primary' : 'border-outlineVariant'
}

type ToggleContainerProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  checked?: boolean
  disabled?: boolean
}

const ToggleContainer = ({ checked, disabled, ...props }: ToggleContainerProps) => (
  <div
    {...props}
    className={cn(
      'flex justify-evenly gap-0 border border-solid rounded-700 h-[38px] w-full transition-[transform_0.2s_ease-in-out] appearance-none m-0 text-[length:inherit] py-[10px] px-50 z-0 focus:outline-0 focus:shadow-none mt-350 grid-cols-[1/-1] items-center place-self-center max-w-[318px] laptop:grid-cols-[2/span_4] laptop:justify-between',
      borderClassName(checked, disabled),
      checked ? 'translate-x-200' : 'translate-x-0',
      props.className,
    )}
  />
)

type ToggleElementProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  checked?: boolean
}

const ToggleElement = ({ checked, ...props }: ToggleElementProps) => (
  <div
    {...props}
    className={cn(
      'h-350 rounded-[22px] flex grow flex-row justify-center items-center cursor-pointer laptop:w-[290px]',
      checked ? 'bg-primary text-onPrimary' : 'bg-none text-onSurfaceVariant',
      props.className,
    )}
  />
)

const MonthlyToggle = addClassNameTo(ToggleElement, /* cn */ 'laptop:w-[113px]')

const QuarterlyToggle = addClassNameTo(MonthlyToggle, /* cn */ 'gap-50 items-baseline pt-50 laptop:w-[181px]')

export const BillingTermsToggle = ({
  monthlySelected,
  onMonthlySelected,
  onQuarterlySelected,
}: {
  monthlySelected: boolean
  onMonthlySelected: () => void
  onQuarterlySelected: () => void
}) => {
  return (
    <ToggleContainer role="radiogroup">
      <MonthlyToggle
        checked={monthlySelected}
        aria-checked={monthlySelected}
        tabIndex={0}
        onKeyDown={() => {}}
        role="radio"
        onClick={() => {
          onMonthlySelected()
        }}
        data-testid="prime:plan:frequency:monthly"
        className={monthlySelected ? 'bg-prime' : ''}
      >
        <p className={cn('body2-emphasized', monthlySelected ? 'text-onPrime' : 'text-onSurfaceVariant')}>
          Pay monthly
        </p>
      </MonthlyToggle>
      <QuarterlyToggle
        checked={!monthlySelected}
        aria-checked={!monthlySelected}
        tabIndex={0}
        onKeyDown={() => {}}
        role="radio"
        onClick={() => {
          onQuarterlySelected()
        }}
        data-testid="prime:plan:frequency:quarterly"
        className={!monthlySelected ? 'bg-prime' : ''}
      >
        <p className={cn('body2-emphasized', !monthlySelected ? 'text-onPrime' : 'text-onSurfaceVariant')}>
          Pay quarterly
        </p>
        <p className={cn('caption2-uppercase', !monthlySelected ? 'text-onPrime' : 'text-super')}>save 20%</p>
      </QuarterlyToggle>
    </ToggleContainer>
  )
}
